import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppForumTopicResponsePage } from './app-forum-topic-response';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppForumTopicResponsePage,
  ],
  imports: [
    IonicPageModule.forChild(AppForumTopicResponsePage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppForumTopicResponsePageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-forum-topic-response/app-forum-topic-response.module.ts